import {
  useMutation,
  useQueries,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";

import { PER_PAGE_DEFAULT, QUERY_NAME, SERVICES } from "@lhd/constants";
import axios from "@lhd/libs/axios";
import { getCompanyId } from "@lhd/utility";
import axiosInstanceV2 from "@lhd/libs/axiosV2";
import { SalaryWorkerFilterConfig } from "./salaryWorkers";

const fetchStaffTaxSheets = async (
  year: any,
  companyId: any,
  filter_config?: SalaryWorkerFilterConfig,
) => {
  return await axiosInstanceV2({
    method: "get",
    url: SERVICES.WORKER_TAXSHEETS,
    params: {
      company_id: companyId,
      page: 1,
      per_page: PER_PAGE_DEFAULT,
      "q[company_id_eq]": companyId,
      "q[year_cycle_eq]": year,
      ...filter_config,
    },
  }).then((res) => res.data || []);
};

const fetchWorkers = async (companyId: any) => {
  return await axiosInstanceV2({
    method: "get",
    url: `${SERVICES.WORKERS}/worker_list_no_permission`,
    params: {
      page: 1,
      per_page: PER_PAGE_DEFAULT,
      "q[company_id_eq]": companyId,
    },
  }).then((res) => res.data || []);
};

export const usePromiseSettledStaffTaxSheets = (
  year: any,
  filter_config?: SalaryWorkerFilterConfig,
  query: any = {},
) => {
  const companyId = getCompanyId();
  const queryConfig = {
    staleTime: 300,
    cacheTime: 300,
    retry: 1,
    enabled: !!year,
    ...query,
  };

  return useQueries({
    queries: [
      {
        queryKey: [QUERY_NAME.STAFF_TAX_SHEETS, year, companyId, filter_config],
        queryFn: () => fetchStaffTaxSheets(year, companyId, filter_config),
        ...queryConfig,
      },
      {
        queryKey: [QUERY_NAME.STAFF_TAX_SHEETS + "Worker", companyId],
        queryFn: () => fetchWorkers(companyId),
        ...queryConfig,
      },
    ],
  });
};

export const useFetchOneStaffTaxSheet = (
  year: any,
  worker_id: number,
  target_month?: number,
) => {
  const companyId = getCompanyId();

  return useQuery(
    [
      QUERY_NAME.STAFF_TAX_SHEETS + "_by_worker_id",
      worker_id,
      year,
      companyId,
      target_month,
    ],
    () =>
      axios({
        method: "get",
        url: `${SERVICES.WORKER_TAXSHEETS}/${worker_id}`,
        params: {
          company_id: companyId,
          year_cycle: year,
        },
      }).then((res) => res.data as any),
    {
      cacheTime: 3000,
      staleTime: 3000,
      enabled: !!worker_id && !!year && year !== "null",
      retry: 2,
    },
  );
};

export const useSubmitStaffTaxSheets = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ payload }: any) =>
      axiosInstanceV2({
        method: "post",
        url: SERVICES.WORKER_TAXSHEETS_SAVE,
        data: payload,
      }),
    {
      onSuccess() {
        queryClient.invalidateQueries([QUERY_NAME.STAFF_TAX_SHEETS]);
        // notification["success"]({
        //   message: "保存しました",
        // });
      },
    },
  );
};
